<template>
  <div class="mobile-app">
    <h3 class="mobile-app__title">
      {{ title }}
    </h3>
    <Link
      :href="href"
      target="_blank"
      class="mobile-app__link">
      <img
        :src="icon"
        alt="mobile app"
        class="mobile-app__img">
    </Link>
  </div>
</template>

<script>
import Link from '@rr-component-library/link/src/main';

export default {
  components: {
    Link,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./MobileApp";
</style>
